import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-gap-[4px] tw-items-center" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "16",
  viewBox: "0 0 8 16",
  fill: "none"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'riskActionsIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: "M0.373575 4.60371C0.417337 4.71024 0.491652 4.80143 0.587156 4.86579C0.68266 4.93015 0.795077 4.9648 0.910242 4.96538L2.66024 4.96538C2.67941 4.96294 2.69888 4.96433 2.71751 4.96948C2.73614 4.97463 2.75356 4.98343 2.76876 4.99537C2.78396 5.00731 2.79663 5.02215 2.80604 5.03904C2.81545 5.05592 2.82141 5.0745 2.82357 5.09371L2.82357 14.1354C2.82357 14.3674 2.91576 14.59 3.07985 14.7541C3.24395 14.9182 3.46651 15.0104 3.69857 15.0104C3.93064 15.0104 4.1532 14.9182 4.31729 14.7541C4.48139 14.59 4.57357 14.3674 4.57357 14.1354L4.57357 5.09371C4.57357 5.05503 4.58894 5.01794 4.61629 4.99059C4.64364 4.96324 4.68073 4.94788 4.71941 4.94788L6.46941 4.94788C6.58477 4.94739 6.69741 4.91271 6.79306 4.84822C6.88872 4.78372 6.96311 4.69231 7.00681 4.58554C7.05052 4.47877 7.06158 4.36144 7.03861 4.24838C7.01564 4.13532 6.95965 4.03162 6.87774 3.95038L4.09524 1.16204C4.04101 1.10737 3.9765 1.06397 3.90541 1.03436C3.83433 1.00474 3.75808 0.989493 3.68107 0.989493C3.60407 0.989493 3.52782 1.00474 3.45674 1.03436C3.38565 1.06397 3.32114 1.10737 3.26691 1.16204L0.484409 3.95038C0.401834 4.03517 0.347009 4.14308 0.327212 4.25978C0.307416 4.37647 0.323586 4.49642 0.373575 4.60371Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ])),
    (_openBlock(), _createElementBlock("svg", _hoisted_4, [
      _createElementVNode("path", {
        d: "M11.1502 2.55011H0.900288C0.450291 2.55011 0.050293 2.15011 0.050293 1.70011V0.850117C0.050293 0.40012 0.450291 0.00012207 0.900288 0.00012207H11.1502C11.6002 0.00012207 12.0002 0.40012 12.0002 0.850117V1.70011C12.0002 2.15011 11.6002 2.55011 11.1502 2.55011Z",
        fill: __props.color
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M8.30024 7.30011H0.900288C0.450291 7.30011 0.050293 6.90011 0.050293 6.45011V5.60012C0.050293 5.15012 0.450291 4.75012 0.900288 4.75012H8.30024C8.75024 4.75012 9.15024 5.15012 9.15024 5.60012V6.45011C9.15024 6.90011 8.80024 7.30011 8.30024 7.30011Z",
        fill: __props.color
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M5.50026 11.9998H0.900288C0.450291 11.9998 0.050293 11.5998 0.050293 11.1498V10.2998C0.050293 9.84983 0.450291 9.44983 0.900288 9.44983H5.50026C5.95026 9.44983 6.35025 9.84983 6.35025 10.2998V11.1498C6.35025 11.5998 6.00026 11.9998 5.50026 11.9998Z",
        fill: __props.color
      }, null, 8, _hoisted_7)
    ]))
  ]))
}
}

})